import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Select,
  FormControl,
  Tabs,
  Tab,
  RadioGroup,
  Radio,
  useMediaQuery,
} from "@mui/material";
import { Iconify, MuiSelect } from "src/components";
import ReactDatePicker from "src/components/task-components/ReactDatePicker";
import moment from "moment";
import CustomRecurrenceDialog from "./CustomRecurrenceDialog";
import {
  _create_recurring_task,
  _update_calendar_event,
} from "src/DAL/dashboard";
import { useSnackbar } from "notistack";
import {
  _project_list_for_task_shift,
  _project_sections_filter,
  _user_workspaces,
} from "src/DAL";
import MuiAutoCompleteCopySections from "src/pages/template-project/components/MuiAutoCompleteCopySections";
import { DataArrayRounded } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import RichEditor from "src/components/editor/RichEditor";
import { event } from "jquery";
import AskForChangesDialog from "./AskForChangesDialog";
import CustomTaskRecurrence from "./CustomTaskRecurrence";

// import EventAsTaskDialog from "./EventAsTaskDialog";

export default function RecurringEventDialog({
  open,
  setOpen,
  selectedDate,
  getCalendarTasks = () => {},
  closeListDialog = () => {},
  // When Edit Event--------------------
  preFillData,
  isEditing = false,
  setIsEditing,
  handleCloseEventDalog,
  // When convert task into Event-------
  task,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const autoFocusRef = useRef(null);
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  const [eventTitle, setEventTitle] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [selectedRecurringDay, setSelectedRecurringDay] = useState(null);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [repeatValue, setRepeatValue] = useState("not_repeat"); // repeat / donot repeate
  const [openCustomModal, setOpenCustomModal] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [optionEvent, setOptionEvent] = useState("single");
  const [optionChangesDialog, setOptionChangesDialog] = useState(false);
  // -------------------------- Event as a task Dialog
  const [isChecked, setIsChecked] = useState(false);
  const [workspaceLoading, setWorkspaceLoading] = useState(false);
  const [projectLoading, setProjectLoading] = useState(false);
  const [sectionLoading, setSectionLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [createEventLoading, setCreateEventLoading] = useState(false);

  const [autoCompleteValues, setAutoCompleteValues] = useState({
    workspace: null,
    project: null,
    section: null,
  });
  const [autoCompleteOptions, setAutoCompleteOptions] = useState({
    workspaces: [],
    projects: [],
    sections: [],
  });

  const [offSetValue, setOffSetValue] = useState(0);
  // -------------------------- CustomRecurrenceDialog states
  const [intervalValue, setIntervalValue] = useState(1);
  const [occurrenceValue, setOccurrenceValue] = useState(1);
  const [intervalType, setIntervalType] = useState("weekly");
  const [days, setDays] = useState([1, 2, 3]);
  const [option, setOption] = useState("after");
  const [endDate, setEndDate] = useState(null);
  const [selectedColor, setSelectedColor] = useState("#969292");
  const [monthlySelectedDays, setMonthlySelectedDays] = useState([]);
  const [yearlyFormattedDate, setYearlyFormattedDate] = useState("");

  const colorOptions = [
    { name: "Gray", color: "#969292" },
    { name: "Green", color: "#2ECC71" },
    { name: "Dark Green", color: "#0B8043" },
    { name: "Yellow", color: "#F6BF26" },
    { name: "Red", color: "#E67C73" },
    { name: "Orange", color: "#FF5733" },
    { name: "Light Blue", color: "#33B5E5" },
    { name: "Blue", color: "#3366FF" },
    { name: "Indigo", color: "#3F51B5" },
    { name: "Purple", color: "#9B59B6" },
  ];

  const handleChangeRepeat = (event) => {
    const value = event.target.value;
    setRepeatValue(value);
  };

  const handleCustomModalClose = () => {
    setOpenCustomModal(false);
  };

  const handleOpenDatePicker = () => {
    setOpenDatePicker(true);
  };
  const handleOffsetChange = (event) => {
    setOffSetValue(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
    if (selectedDate) {
      setStartDate(selectedDate);
      setEndDate(selectedDate);
    }
    setEventTitle("");
    setEventDescription("");
    setSelectedRecurringDay(null);
    setOptionEvent("single");
    setRepeatValue("not_repeat");
    setIntervalValue(1);
    setOccurrenceValue(1);
    setIntervalType("weekly");
    setDays([1]);
    setOption("after");
    setSelectedColor("#969292");
    setMonthlySelectedDays([]);
    setIsChecked(false);
    setIsEditing?.(false); // safe check if undefined
    setHasChanges(false);
    resetAutoCompleteStates();
  };

  const resetAutoCompleteStates = () => {
    setOffSetValue(0);
    setAutoCompleteValues({
      project: null,
      section: null,
      workspace: null,
    });
    setAutoCompleteOptions({
      projects: [],
      sections: [],
      workspaces: [],
    });
  };

  const handleSave = () => {
    const { section, project, workspace } = autoCompleteValues;
    if (isChecked && !section) {
      enqueueSnackbar("Please select workspace, project & section to proceed", {
        variant: "warning",
      });
      return;
    }

    let req_data;
    if (repeatValue === "custom") {
      req_data = {
        task_id: task ? task._id : null,
        event_title: eventTitle,
        interval_type: intervalType,
        number_of_intervals: intervalValue,
        recurring_start_date: moment(startDate).format("YYYY-MM-DD"), // 2025-4-13 format
        color: selectedColor,
        task_generated: isChecked, // true for task || fasle for event
        creation_date_offset: isChecked === true ? offSetValue : 0, // task create early
        end_date_type: option === "on" ? 1 : 2, // 1 = end_date required || 2 = number_of_occurence required
        recurring_end_date:
          option === "on" && endDate
            ? moment(endDate).format("YYYY-MM-DD")
            : null,
        number_of_occurances:
          option === "after" && occurrenceValue ? occurrenceValue : null,
        specified_days:
          intervalType === "weekly"
            ? days
            : intervalType === "monthly"
            ? monthlySelectedDays
            : intervalType === "yearly"
            ? [moment(yearlyFormattedDate).format("YYYY-MM-DD")] // 2025-4-13 format
            : [],
        workspace_id: isChecked === true ? workspace._id : null,
        project_id: isChecked === true ? project._id : null,
        section_id: isChecked === true ? section._id : null,
        event_description: eventDescription,
        task_priority: "3",
      };
    } else {
      req_data = {
        task_id: task ? task._id : null,
        event_title: eventTitle,
        interval_type: "daily", // "daily","weekly", "monthly", "yealy",
        number_of_intervals: 1,
        recurring_start_date: moment(startDate).format("YYYY-MM-DD"),
        color: selectedColor,
        task_generated: isChecked, // true for task || fasle for event
        creation_date_offset: isChecked === true ? offSetValue : 0,
        number_of_occurances: 1,
        end_date_type: 2, // 1 = end_date required || 2 = number_of_occurence required
        recurring_end_date: null,
        specified_days: [],
        workspace_id: isChecked === true ? workspace._id : null,
        project_id: isChecked === true ? project._id : null,
        section_id: isChecked === true ? section._id : null,
        event_description: eventDescription,
        task_priority: "3",
      };
    }

    console.log(req_data, "Payload");
    createRecurringTask(req_data);
  };

  const createRecurringTask = async (data) => {
    setCreateEventLoading(true);
    const result = await _create_recurring_task(data);
    if (result.code == 200) {
      enqueueSnackbar(
        task
          ? "Recurring task scheduled successfully"
          : "Event created successfully",
        { variant: "success" }
      );
      getCalendarTasks();
      handleClose();
      closeListDialog();
    } else {
      console.error(result.message);
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setCreateEventLoading(false);
  };

  // ----------------------------
  const getWorkspaces = async () => {
    const result = await _user_workspaces();
    const getPersonal = (_data) =>
      _data.map((item) => ({
        ...item,
        role: "admin",
        workspace_type: "mine",
      }));

    const getShared = (_data) =>
      _data.map((item) => ({
        ...item,
        workspace_type: "shared",
      }));
    if (result.code === 200) {
      console.log(result, "workspace-res");

      const personal = getPersonal(result.workspace.personal || []);
      const shared = getShared(result.workspace.share || []);
      const combined = [...personal, ...shared];

      setAutoCompleteOptions((prev) => ({
        ...prev,
        workspaces: combined.map((workspace) => ({
          ...workspace,
          label: workspace.name,
          value: workspace,
        })),
      }));
      setWorkspaceLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setWorkspaceLoading(false);
  };

  const getProjects = async () => {
    setProjectLoading(true);
    const result = await _project_list_for_task_shift(
      autoCompleteValues.workspace._id
    );
    if (result.code === 200) {
      setAutoCompleteOptions((prev) => {
        return {
          ...prev,
          projects: result.project_list.project_list.map((project) => {
            return { ...project, label: project.title, value: project };
          }),
          sections: [],
        };
      });
      setProjectLoading(false);
      console.log(autoCompleteOptions, "options_");
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setProjectLoading(false);
  };

  const getSections = async () => {
    setSectionLoading(true);
    const result = await _project_sections_filter(
      {
        list_type: 0,
        priority: [],
        sort_status: "",
        task_status: [],
        workspace_id: autoCompleteValues.workspace._id,
      },
      autoCompleteValues.project._id,
      0,
      200
    );
    if (result.code == 200) {
      setAutoCompleteOptions((prev) => {
        return {
          ...prev,
          sections: result.section_list.section_lists.map((section) => {
            return {
              ...section,
              label: section.section_title,
              value: section,
            };
          }),
        };
      });
      setSectionLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setSectionLoading(false);
  };

  // ====================== update event =======================

  const updateCalanderEvents = async () => {
    if (!(preFillData && isEditing)) {
      return;
    }

    let req_data;
    if (repeatValue === "custom") {
      req_data = {
        event_id: preFillData._id,
        event_title: eventTitle,
        interval_type: intervalType,
        number_of_intervals: intervalValue,
        recurring_start_date: moment(startDate).format("YYYY-MM-DD"), // 2025-4-13 format
        color: selectedColor,
        task_generated: false, // true for task || fasle for event
        creation_date_offset: 0,
        end_date_type: option === "on" ? 1 : 2, // 1 = end_date required || 2 = number_of_occurence required
        recurring_end_date:
          option === "on" && endDate
            ? moment(endDate).format("YYYY-MM-DD")
            : null,
        number_of_occurances:
          option === "after" && occurrenceValue ? occurrenceValue : null,
        specified_days:
          intervalType === "weekly"
            ? days
            : intervalType === "monthly"
            ? monthlySelectedDays
            : intervalType === "yearly"
            ? [moment(yearlyFormattedDate).toISOString()] // 2025-4-13 format
            : [],
        is_schedule_recalculate: hasChanges, // set it true for update the reccurence dates
        event_description: eventDescription,
        task_priority: "3",
        occurance_id:
          optionEvent === "single" || optionEvent === "following"
            ? selectedRecurringDay._id
            : null,
        edit_single_occurance: optionEvent === "single" ? true : false,
      };
    } else {
      req_data = {
        event_id: preFillData._id,
        event_title: eventTitle,
        interval_type: "daily", // "daily","weekly", "monthly", "yealy",
        number_of_intervals: 1,
        recurring_start_date: moment(startDate).format("YYYY-MM-DD"),
        color: selectedColor,
        task_generated: false, // true for task || fasle for event
        creation_date_offset: 0, // task create early
        number_of_occurances: 1,
        end_date_type: 2, // 1 = end_date required || 2 = number_of_occurence required
        recurring_end_date: null,
        specified_days: [],
        is_schedule_recalculate: true,
        event_description: eventDescription,
        task_priority: "3",
        occurance_id: null,
        edit_single_occurance: false,
      };
    }

    console.log(req_data, "Payload");
    setUpdateLoading(true);
    const result = await _update_calendar_event(req_data);
    if (result.code === 200) {
      enqueueSnackbar("Calendar event updated successfully", {
        variant: "success",
      });
      getCalendarTasks();
      handleClose();
      closeListDialog();
      handleCloseEventDalog();
      setUpdateLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setUpdateLoading(false);
  };

  useEffect(() => {
    if (isChecked) {
      getWorkspaces();
      setWorkspaceLoading(true);
    }
  }, [isChecked]);

  useEffect(() => {
    if (autoCompleteValues.workspace) {
      getProjects();
    }
  }, [autoCompleteValues.workspace]);

  useEffect(() => {
    if (autoCompleteValues.project) {
      getSections();
    }
  }, [autoCompleteValues.project]);

  useEffect(() => {
    if (selectedDate) {
      setStartDate(selectedDate);
    }
  }, [selectedDate]);

  // ======================== pre filled for edit event ========================

  useEffect(() => {
    if (preFillData && isEditing && selectedDate) {
      console.log(preFillData, "pre_fill_data");
      const data = preFillData;

      const selectedDay = preFillData.recurring_dates.find((item) =>
        moment(item.actual_time).isSame(moment(selectedDate), "day")
      );

      setSelectedRecurringDay(selectedDay);
      setEventDescription(selectedDay?.event_data?.event_description);

      // -----------------------------------------------------------------------------
      if (data.number_of_occurances <= 1) {
        setRepeatValue("not_repeat");
      } else {
        setRepeatValue("custom");
      }
      setEventTitle(data.event_title);
      setSelectedColor(data.color);
      setStartDate(data.recurring_start_date);
      setIntervalValue(data.number_of_intervals);
      setIntervalType(data.interval_type);
      if (data.interval_type === "daily") {
        setEndDate(data.recurring_end_date);
      }
      setOccurrenceValue(data.number_of_occurances);
      if (data.end_date_type === 2) {
        setOption("after");
      } else if (data.end_date_type == 1) {
        setOption("on");
        setEndDate(data.recurring_end_date);
      }
      if (data.specified_days && data.specified_days.length > 0) {
        // Weekly
        if (data.interval_type === "weekly") {
          setDays(data.specified_days.map(Number));
        }
        // Monthly
        if (data.interval_type === "monthly") {
          setMonthlySelectedDays(data.specified_days.map(Number));
        }
        // Yearly
        if (data.interval_type === "yearly") {
          setYearlyFormattedDate(data.specified_days);
        }
      }
    }
  }, [preFillData, isEditing, selectedDate]);

  useEffect(() => {
    if (task && open) {
      setEventTitle(task?.task_title);
      setIsChecked(true);
    }
  }, [task, open]);

  useEffect(() => {
    if (open) {
      // use delay to set autofocus for dialog open
      setTimeout(() => {
        autoFocusRef.current.focus();
      }, 300);
    }
  }, [open]);

  return (
    <>
      <Dialog
        className="recurring-task-dialog"
        // fullWidth
        sx={{ "& .MuiDialog-paper": { width: 600 } }}
        open={open}
        onClose={handleClose}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (preFillData && isEditing) {
              if (repeatValue !== "not_repeat") {
                setOptionChangesDialog(true); // open dialog instead of updating directly
              } else {
                updateCalanderEvents(); // directly update if it's not a recurring event
              }
            } else {
              handleSave(); // normal save for new event
            }
          }}
        >
          <DialogTitle sx={{ p: "16px 20px 8px 20px" }}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {task ? (
                <div>Create Recurring Task</div>
              ) : (
                <div className="d-flex align-items-center">
                  <Iconify
                    icon="simple-line-icons:calender"
                    style={{ marginRight: "8px" }}
                  />
                  {moment(selectedDate).format("dddd, D MMMM YYYY")}
                </div>
              )}

              <IconButton size="small" onClick={handleClose}>
                <Iconify
                  icon="ion-close"
                  sx={{ height: "24px", width: "24px" }}
                />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent
            sx={is_mobile_view ? { p: "10px" } : { py: "10px", px: "24px" }}
          >
            <div className="event-title">
              <Typography sx={{ fontSize: "12px", fontWeight: 500, mb: 1 }}>
                {task ? "Task" : "Event"} Title
              </Typography>
              <TextField
                autoFocus
                inputRef={autoFocusRef}
                className="add-event-input"
                size="small"
                placeholder="Add Title"
                value={eventTitle}
                disabled={task ? true : false}
                onChange={(event) => setEventTitle(event.target.value)}
                required
                fullWidth
              />
            </div>
            {!task && ( // hide  when task recurring ---------------
              <div className="mt-3">
                <div className="d-flex gap-2 align-items-center">
                  <div>
                    <Typography
                      sx={{ fontSize: "12px", fontWeight: 500, mb: 0.5 }}
                    >
                      {task ? "Recurring Start" : "Event"} Date
                    </Typography>
                    <ReactDatePicker
                      isOpen={openDatePicker}
                      setIsOpen={setOpenDatePicker}
                      handleOpen={handleOpenDatePicker}
                      timeDate={startDate}
                      setTimeDate={setStartDate}
                      disablePastDates={false}
                    />
                  </div>
                  <div className="recurrence-menu">
                    <Typography
                      sx={{ fontSize: "12px", fontWeight: 500, mb: 1 }}
                    >
                      Recurrence
                    </Typography>
                    <Box sx={{ maxWidth: 300 }}>
                      <FormControl fullWidth>
                        <Select
                          disabled={
                            preFillData &&
                            isEditing &&
                            repeatValue === "not_repeat"
                          }
                          size="small"
                          labelId="repeat-option-new-label"
                          id="repeat-option-new-select"
                          value={repeatValue}
                          onChange={handleChangeRepeat}
                        >
                          <MenuItem
                            value="not_repeat"
                            disabled={
                              preFillData &&
                              isEditing &&
                              repeatValue === "custom"
                            }
                          >
                            Do not repeat
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              setOpenCustomModal(true);
                            }}
                            value="custom"
                            disabled={
                              preFillData &&
                              isEditing &&
                              repeatValue === "not_repeat"
                            }
                          >
                            Custom
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
                  <div className="event-color">
                    <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                      Event Color
                    </Typography>
                    <div>
                      <Select
                        value={selectedColor}
                        onChange={(e) => setSelectedColor(e.target.value)}
                        size="small"
                        sx={{ mt: 1 }}
                      >
                        {colorOptions.map(({ name, color }) => (
                          <MenuItem key={color} value={color}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 16,
                                  height: 16,
                                  borderRadius: "50%",
                                  backgroundColor: color,
                                  border: "1px solid #ccc",
                                }}
                              />
                              <span>{name}</span>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  {repeatValue === "custom" && (
                    <div className="custom-options ">
                      <Iconify
                        icon="material-symbols:event"
                        style={{
                          fontSize: "16px",
                          flexShrink: 0,
                          color: "#637381",
                        }}
                      />

                      <Typography sx={{ fontSize: "12px" }}>
                        {(option !== "on" &&
                          occurrenceValue <= 1 &&
                          intervalType === "daily") ||
                        (option === "on" &&
                          intervalType === "daily" &&
                          moment(startDate).format("YYYY-MM-DD") ===
                            moment(endDate).format("YYYY-MM-DD")) ? (
                          "Do not repeat"
                        ) : (
                          <>
                            {intervalType === "daily"
                              ? intervalValue === 1
                                ? "Every day"
                                : `Every ${intervalValue} days`
                              : intervalType === "weekly"
                              ? `Every ${intervalValue} ${
                                  intervalValue > 1 ? "weeks" : "week"
                                }`
                              : intervalType === "monthly"
                              ? `Every ${intervalValue} ${
                                  intervalValue > 1 ? "months" : "month"
                                }`
                              : intervalType === "yearly"
                              ? `Every ${intervalValue} ${
                                  intervalValue > 1 ? "years" : "year"
                                }`
                              : ""}
                          </>
                        )}

                        {intervalType === "weekly" && days.length > 0 && (
                          <>
                            {" on "}
                            {days.length === 7
                              ? "all days"
                              : [0, 1, 2, 3, 4, 5, 6]
                                  .filter((d) => days.includes(d))
                                  .map(
                                    (d) =>
                                      [
                                        "Sun",
                                        "Mon",
                                        "Tue",
                                        "Wed",
                                        "Thu",
                                        "Fri",
                                        "Sat",
                                      ][d]
                                  )
                                  .join(", ")}
                          </>
                        )}
                        {intervalType === "monthly" && (
                          <>
                            {" "}
                            on{" "}
                            {monthlySelectedDays.includes(-1)
                              ? "Last Day"
                              : `Day ${monthlySelectedDays.join(", ")}`}
                          </>
                        )}

                        {intervalType === "yearly" && (
                          <>
                            {" "}
                            on {moment(yearlyFormattedDate).format("D MMMM")}
                          </>
                        )}
                        {/* if do not reapeate dont show  */}
                        {(occurrenceValue > 1 || option === "on") && (
                          <>
                            {option !== "after" &&
                              moment(startDate).format("YYYY-MM-DD") !==
                                moment(endDate).format("YYYY-MM-DD") && (
                                <>
                                  {" "}
                                  , Until{" "}
                                  {moment(endDate).format("D MMMM yyyy")}
                                </>
                              )}

                            {option === "after" && (
                              <> , Repeat {occurrenceValue} Times</> 
                            )}
                          </>
                        )}
                      </Typography>

                      {repeatValue === "custom" && (
                        <Button
                          variant="text"
                          size="small"
                          sx={{ minWidth: "45px" }}
                          onClick={() => {
                            setOpenCustomModal(true);
                            setHasChanges(true);
                          }}
                        >
                          Edit
                        </Button>
                      )}
                    </div>
                  )}
                </div>
                {/*Show when editing true or have no event_data for new evnet create */}
                {!(isEditing && !selectedRecurringDay?.event_data) && (
                  <div className="mt-3 event-description">
                    <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                      Event Description
                    </Typography>
                    <Box sx={{ mt: 0.5 }}>
                      <RichEditor
                        value={eventDescription}
                        setValue={setEventDescription}
                        editorHeight="150px"
                      />
                    </Box>
                  </div>
                )}
                {/* only show when not Editing and no task recurring */}
                {!isEditing && !task && (
                  <div className="mt-2">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setIsChecked(true);
                            } else {
                              setIsChecked(false);
                              resetAutoCompleteStates();
                            }
                          }}
                        />
                      }
                      label={
                        <Typography sx={{ fontSize: 13 }}>
                          Create this event as a task
                        </Typography>
                      }
                    />
                  </div>
                )}
              </div>
            )} 

            {task && (
              <div className="mt-3">
                <div className="mb-3 d-flex align-items-center gap-3">
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    Start Date
                  </Typography>
                  <ReactDatePicker
                    isOpen={openDatePicker}
                    setIsOpen={setOpenDatePicker}
                    handleOpen={handleOpenDatePicker}
                    timeDate={startDate}
                    setTimeDate={setStartDate}
                    disablePastDates={false}
                  />
                </div>
                <CustomTaskRecurrence
                  startDate={startDate}
                  intervalValue={intervalValue}
                  setIntervalValue={setIntervalValue}
                  occurrenceValue={occurrenceValue}
                  setOccurrenceValue={setOccurrenceValue}
                  intervalType={intervalType}
                  setIntervalType={setIntervalType}
                  days={days}
                  setDays={setDays}
                  option={option}
                  setOption={setOption}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  monthlySelectedDays={monthlySelectedDays}
                  setMonthlySelectedDays={setMonthlySelectedDays}
                  setYearlyFormattedDate={setYearlyFormattedDate}
                  yearlyFormattedDate={yearlyFormattedDate}
                  setRepeatValue={setRepeatValue}
                  repeatValue={repeatValue}
                />
              </div>
            )}

            {isChecked && (
              <div className="mt-3">
                <Box display="flex" flexDirection="column">
                  <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                    Please choose a workspace, project, and section to make this{" "}
                    {task ? "Task Recurring" : "Event a task"}
                  </Typography>
                  <Box
                    display="flex"
                    flexDirection="column"
                    gap={"20px"}
                    pt={"16px"}
                  >
                    {isChecked && (
                      <MuiAutoCompleteCopySections
                        disablePortal
                        label="Select Workspace"
                        value={autoCompleteValues.workspace}
                        options={autoCompleteOptions.workspaces}
                        onChange={(val) =>
                          setAutoCompleteValues({
                            workspace: val,
                            section: null,
                            project: null,
                          })
                        }
                        loading={workspaceLoading}
                        size="small"
                      />
                    )}
                    {/* ----------------- Select Project*/}
                    {autoCompleteValues.workspace && (
                      <MuiAutoCompleteCopySections
                        disablePortal
                        label="Select Project"
                        value={autoCompleteValues.project}
                        options={autoCompleteOptions.projects}
                        onChange={(val) =>
                          setAutoCompleteValues((prev) => ({
                            ...prev,
                            project: val,
                            section: null,
                          }))
                        }
                        loading={projectLoading}
                        size="small"
                      />
                    )}
                    {/* ----------------- Select Section*/}
                    {autoCompleteValues.project && (
                      <MuiAutoCompleteCopySections
                        disablePortal
                        label="Select Section"
                        value={autoCompleteValues.section}
                        options={autoCompleteOptions.sections}
                        onChange={(val) =>
                          setAutoCompleteValues((prev) => ({
                            ...prev,
                            section: val,
                          }))
                        }
                        loading={sectionLoading}
                        size="small"
                      />
                    )}
                  </Box>
                  {autoCompleteValues.section && (
                    <div className="off-set">
                      <Typography
                        sx={{ fontSize: "12px", mb: 1, fontWeight: 500 }}
                      >
                        How many days in advance do you want to create this
                        task?
                      </Typography>

                      <Select
                        value={offSetValue}
                        onChange={handleOffsetChange}
                        size="small"
                        sx={{ width: 180 }}
                      >
                        <MenuItem value={0}>Create Now</MenuItem>
                        <MenuItem value={1}>1 Day before</MenuItem>
                        <MenuItem value={2}>2 Days before</MenuItem>
                        <MenuItem value={3}>3 Days before</MenuItem>
                        <MenuItem value={4}>4 Days before</MenuItem>
                        <MenuItem value={5}>5 Days before</MenuItem>
                        <MenuItem value={6}>6 Days before</MenuItem>
                        <MenuItem value={7}>7 Days before</MenuItem>
                        <MenuItem value={8}>8 Days before</MenuItem>
                        <MenuItem value={9}>9 Days before</MenuItem>
                        <MenuItem value={10}>10 Days before</MenuItem>
                      </Select>

                      {/* {offSetValue && (
                            <div>
                              <Typography sx={{ fontSize: "12px" }}>
                                {`Task will be created on ${moment(startDate)
                                  .subtract(parseInt(offSetValue || 0), "days")
                                  .format("dddd, D MMMM, YYYY")}`}
                              </Typography>
                            </div>
                          )} */}
                    </div>
                  )}
                </Box>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            {isEditing === true ? (
              <LoadingButton
                loading={updateLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                update
              </LoadingButton>
            ) : (
              <LoadingButton
                loading={createEventLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                Create
              </LoadingButton>
            )}
          </DialogActions>
        </form>
      </Dialog>

      {/* Custom Recurrence Dialog ========================================= */}
      <CustomRecurrenceDialog
        open={openCustomModal}
        onClose={handleCustomModalClose}
        startDate={isEditing === true ? endDate : startDate} // for choosing the endDate/Month
        intervalValue={intervalValue}
        setIntervalValue={setIntervalValue}
        occurrenceValue={occurrenceValue}
        setOccurrenceValue={setOccurrenceValue}
        intervalType={intervalType}
        setIntervalType={setIntervalType}
        days={days}
        setDays={setDays}
        option={option}
        setOption={setOption}
        endDate={endDate}
        setEndDate={setEndDate}
        monthlySelectedDays={monthlySelectedDays}
        setMonthlySelectedDays={setMonthlySelectedDays}
        setYearlyFormattedDate={setYearlyFormattedDate}
        setHasChanges={setHasChanges}
      />

      <AskForChangesDialog
        open={optionChangesDialog}
        onClose={() => setOptionChangesDialog(false)}
        optionEvent={optionEvent}
        setOptionEvent={setOptionEvent}
        onConfirm={updateCalanderEvents}
      />
    </>
  );
}
